import moment from 'moment-timezone'

export const calculateRepeatDateFromSchedule = {
  methods: {
    calculateRepeatDateFromSchedule: function (schedule) {
      // if no schedule then stop
      if (!schedule) return ''
      // set up defaults
      let nextRepeats = 'no date'
      // get today
      let today = new Date()
      // get todays year
      let thisYear = today.getFullYear()
      // get todays month
      let thisMonth = today.getMonth()

      // now calculate the next repeating date.
      if (schedule.frequency === 'monthly') {
        // if it's a monthly schedule...
        // then build next repeat date
        nextRepeats = new Date(thisYear, thisMonth, schedule.dayOfMonth)
        // if already missed ths month add a month on
        if (nextRepeats < today) {
          nextRepeats = new Date(thisYear, thisMonth + 1, schedule.dayOfMonth)
        }
      } else {
        // if it's an annual schedule...
        // then build next repeat date
        nextRepeats = new Date(thisYear, schedule.monthOfYear, schedule.dayOfMonth)
        // if already missed ths year add a year on
        if (nextRepeats < today) {
          nextRepeats = new Date(thisYear + 1, schedule.monthOfYear, schedule.dayOfMonth)
        }
      }
      return nextRepeats
    },
    getUTCRepeatDateFromTimeZonedRepeatDate: function (repeatDate, timezone = 'Europe/London') {
      // vairable for if we want to allow custom time of day for creation, probably not necessary
      const hourOfDaytoCreateJob = 0
      // now lets convert this date into the exact UTC time it's to be created based on the users timezone
      // so first we create a moment object in a simple date and hours format
      let momentDate = moment([repeatDate.getFullYear(), repeatDate.getMonth(), repeatDate.getDate(), hourOfDaytoCreateJob]).format('YYYY-MM-DD HH:mm')
      // now we apply the users timezone to this date
      let tzdDate = moment.tz(momentDate, timezone)
      // now return the utc version of this in the ISO format
      // console.log('tz stuff', tzdDate.format('Z z'))
      return moment.utc(tzdDate).toISOString()
    }
  }
}
